import React from "react";

import { ContentReferenceType } from "../../../../../common/types/ContentReferenceType";

export interface CloudFileDashboardContext {
    cloudFileId: string;

    selectedVersionInfo?: VersionInfo;
    setSelectedVersionInfo(info: VersionInfo): void;

    lookupFileRecordId?: string;
    setLookupFileRecordId(fileRecordId: string): void;

    areUnsavedChanges: boolean;
    setAreUnsavedChanges(value: boolean): void;

    isInactiveContentSelected: boolean;
    setIsInactiveContentSelected(value: boolean): void;

    isAssociateFormReady: boolean;
    setIsAssociateFormReady(value: boolean): void;
}

export interface VersionInfo {
    contentType: ContentReferenceType;
    contentId: string;
    versionIds: string[];
}

export const CloudFileDashboardContext = React.createContext<CloudFileDashboardContext>(
    {} as CloudFileDashboardContext
);
